import { Fragment, useState, useEffect } from 'react';

const HeightButton = ({
  displayHeight,
  btnText,
  btnClass,
  path,
  stopHeight,
}) => {
  displayHeight = displayHeight ? displayHeight : 0;
  btnText = btnText ? btnText : 'TRY NOW';
  btnClass = btnClass ? btnClass : 'hr-blue-btn hr-wide height-btn';
  path = path ? path : 'limited-time';
  stopHeight = stopHeight ? stopHeight : Infinity;

  const [isVisible, setVisible] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      let y_cord = window.pageYOffset;
      if (!isVisible && y_cord > displayHeight && y_cord < stopHeight) {
        setVisible(true);
      } else if ((isVisible && y_cord < displayHeight) || y_cord > stopHeight) {
        setVisible(false);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [isVisible]);

  const renderBtn = () => {
    return (
      <div className="cta-wrapper">
        <a href={path} className="cta-link">
          <div className={`${btnClass}`}>{btnText}</div>
        </a>
      </div>
    );
  };

  return <Fragment>{isVisible ? renderBtn() : null}</Fragment>;
};

export default HeightButton;
